import { render, staticRenderFns } from "./RPDatatableLayout.vue?vue&type=template&id=16a244fe&"
import script from "./RPDatatableLayout.vue?vue&type=script&lang=js&"
export * from "./RPDatatableLayout.vue?vue&type=script&lang=js&"
import style0 from "./RPDatatableLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RPDatatableLayout.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports